import React, {useState} from 'react';
import authAxios, { publicAxios } from '../api/axios';

export const UserContext = React.createContext();

const getInitialAuthState = () => {
    try {
        const storedUser = localStorage.getItem('user');
        const storedToken = localStorage.getItem('token');

        if (storedUser && storedUser !== 'undefined' && storedToken && storedToken !== 'undefined') {
            const user = JSON.parse(storedUser);
            if (user && user.name) {
                return { user, token: storedToken, errMsg: '' };
            }
        }
    } catch (e) {
        // Invalid data, clear it
    }

    // Clear invalid auth data
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    return { user: {}, token: '', errMsg: '' };
};

export default function UserProvider(props) {
    const initState = getInitialAuthState();
    const [userState, setuserState] = useState(initState);

    const handleAuthErr = errMsg => {
        setuserState(prevState => ({
            ...prevState,
            errMsg
        }))

    }

    const resetAuthErr = () => {
        setuserState(prevState => ({
            ...prevState,
            errMsg: ''
        }))
    }

    const signup = credentials => {
        publicAxios.post('/signup', credentials)
            .then(res => {
                const {user, token} = res.data;
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));
                setuserState(prevUserState => ({
                    ...prevUserState,
                    user,
                    token
                }))
            })
            .catch(err => handleAuthErr(err.response?.data?.errMsg || err.message || 'An error occurred'))
    }

    const login = credentials => {
        publicAxios.post('/login', credentials)
            .then(res => {
                const {user, token} = res.data;
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));
                setuserState(prevUserState => ({
                    ...prevUserState,
                    user,
                    token
                }))
            })
            .catch(err => handleAuthErr(err.response?.data?.errMsg || err.message || 'An error occurred'))
    }

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setuserState({user: {}, token: ''})
    }

    /**
     * Refresh user information based on token, this is live data and does not require re-authentication.
     */
    const refreshUserInformation = () => {
        if (userState && userState.user !== {}) {
            authAxios.get('/api/jwt-token')
                .then(res => {
                    setuserState(oldUserState => ({...oldUserState, user: res.data}))
                })
                .catch(err => console.log(err));
        }
    }

    const getUserById = (userID, setFunc) => {
        authAxios.get(`/api/user/${userID}`)
            .then(res => {
                setFunc(res.data);
            })
            .catch(err => console.log(err));
    }

    const getNameOfUser = () => {
        return userState.user.username;
    }

    return (
        <UserContext.Provider value={
            {
                ...userState,
                signup,
                login,
                logout,
                resetAuthErr,
                getUserById,
                getNameOfUser,
            }}>
            {props.children}
        </UserContext.Provider>
    )
}